export default "__VITE_ASSET__5ac29ebc__"